import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var borrowerListColumns = function borrowerListColumns(roleData) {
  return [{
    name: 'ЕГН',
    render: function render(borrower) {
      return ___EmotionJSX(Link, {
        to: {
          pathname: "borrowers/details/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number),
          state: {
            borrower: borrower
          }
        }
      }, borrower === null || borrower === void 0 ? void 0 : borrower.id_number);
    }
  }, {
    name: 'Име',
    render: function render(_ref) {
      var first_name = _ref.first_name,
          middle_name = _ref.middle_name,
          last_name = _ref.last_name;
      return ___EmotionJSX("span", null, "".concat(first_name, " ").concat(middle_name, " ").concat(last_name));
    }
  }, {
    name: 'Телефони',
    render: function render(_ref2) {
      var phones = _ref2.phones;
      return ___EmotionJSX("div", null, phones === null || phones === void 0 ? void 0 : phones.map(function (el) {
        return ___EmotionJSX("p", {
          key: el
        }, el);
      }));
    },
    width: '150px'
  }, {
    name: 'Брой кредити',
    render: function render(_ref3) {
      var credits_count = _ref3.credits_count;
      return ___EmotionJSX("span", null, credits_count);
    },
    width: '120px'
  }, {
    name: 'Искания за кредит',
    render: function render(_ref4) {
      var credit_requests_count = _ref4.credit_requests_count;
      return ___EmotionJSX("span", null, credit_requests_count);
    },
    width: '120px'
  }, {
    name: 'Активни кредити',
    render: function render(_ref5) {
      var active_credits_count = _ref5.active_credits_count;
      return ___EmotionJSX("span", null, active_credits_count);
    },
    width: '120px'
  }, {
    name: 'Просрочие',
    render: function render(_ref6) {
      var has_late_payments = _ref6.has_late_payments;
      return ___EmotionJSX("span", null, has_late_payments ? 'ДА' : 'НЕ');
    },
    width: '100px'
  }, (roleData === null || roleData === void 0 ? void 0 : roleData.canViewEmployees) && {
    name: 'Служител',
    value: 'employee.name',
    width: '160px',
    invisibleBelow: 1600
  }, (roleData === null || roleData === void 0 ? void 0 : roleData.canViewOffices) && {
    name: 'Офис',
    value: 'office.name',
    width: '160px',
    invisibleBelow: 1600
  }, {
    name: 'Действие',
    render: function render(borrower) {
      return ___EmotionJSX(TableActions, {
        mainAction: {
          linkTo: {
            pathname: "/borrowers/details/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number),
            state: {
              borrower: borrower
            }
          },
          leftIcon: {
            iconName: 'la la-info',
            size: 20
          },
          css: detailsBtn
        },
        actionsList: [{
          label: 'Създай кредит',
          linkTo: {
            pathname: '/credits/new',
            state: {
              borrowerIdNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number
            }
          }
        }, {
          label: 'Провери ЦКР',
          linkTo: {
            pathname: "/borrowers/ckr/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number),
            state: {
              borrower: borrower
            }
          }
        }, {
          label: 'Въведи вноска',
          linkTo: "/borrowers/details/".concat(borrower === null || borrower === void 0 ? void 0 : borrower.id_number, "/credits")
        }]
      });
    },
    width: '90px'
  }].filter(Boolean);
};